import { Text } from "@mantine/core"
import { ColumnDef, createColumnHelper } from "@tanstack/react-table"
import { useMemo } from "react"

import { AdminResponses } from "@tfg/types/endpoints/admin"

export const useGetAgecExportColumns = (): ColumnDef<
  AdminResponses.OrganizationAgecStats,
  any
>[] => {
  const columnHelper =
    createColumnHelper<AdminResponses.OrganizationAgecStats>()

  return useMemo<ColumnDef<AdminResponses.OrganizationAgecStats, any>[]>(
    () => [
      columnHelper.accessor("companyName", {
        enableSorting: false,
        header: "Company Name",
        cell: ({ getValue }) => <Text>{getValue()}</Text>,
      }),
      columnHelper.accessor("collection", {
        enableSorting: false,
        header: "Collection",
        cell: ({ getValue }) => <Text>{getValue()}</Text>,
      }),
      columnHelper.accessor("totalproducts", {
        enableSorting: false,
        header: "Total products",
        cell: ({ getValue }) => <Text ta="center">{getValue()}</Text>,
      }),
      columnHelper.accessor("agecCompliantProducts", {
        enableSorting: false,
        header: "Compliant Products",
        cell: ({ getValue }) => (
          <Text ta="center" c="green" fw={700}>
            {getValue()}
          </Text>
        ),
      }),
      columnHelper.accessor("agecNotCompliantProducts", {
        enableSorting: false,
        header: "Not Compliant Products",
        cell: ({ getValue }) => (
          <Text ta="center" c="red" fw={700}>
            {getValue()}
          </Text>
        ),
      }),
      columnHelper.accessor("compliantPercentage", {
        enableSorting: false,
        header: "Compliance percentage",
        size: 100,
        cell: ({ getValue }) => (
          <Text ta="end" mr="1em" fw={700}>
            {Number(getValue()) + "%"}
          </Text>
        ),
      }),
    ],
    [columnHelper]
  )
}
